module.exports = __webpack_public_path__ + "img/vintage-robot.aaa995d3.svg";